import { render } from "./FilesInput.vue?vue&type=template&id=5c88618f&scoped=true"
import script from "./FilesInput.vue?vue&type=script&lang=js"
export * from "./FilesInput.vue?vue&type=script&lang=js"

import "./FilesInput.vue?vue&type=style&index=0&id=5c88618f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c88618f"]])

export default __exports__